import { CardContent } from '@mui/material'
import { useRouteQuery } from '@hooks/useRouteQuery'
import { BoxPage } from '@/components/common'
import { Card } from '@/@core/components/mui/Card'
import { ActivityLogTypeEnum, Company, RoleIdEnum } from '@/@data'
import { EmployerTableFilter } from '@/components/employer/EmployerTableFilter'
import { EmployerTable } from '@/components/employer/EmployerTable'
import { useQuery } from '@tanstack/react-query'
import { CreateEmployerDrawer } from '@/components/employer/CreateEmployerDrawer'
import { useState, useMemo, useEffect } from 'react'
import { useTranslator } from '@/hooks'
import AppLogs from '@/components/common/AppLogs'
import { useAppSelector } from '@/redux-store'
import type { RootState } from '@/redux-store'

const Employer = () => {
  const { searchQuery, updateQuery } = useRouteQuery()
  const { __ } = useTranslator()
  const { serializeQuery } = useRouteQuery()
  const [isOpenCreateEmployerDrawer, setIsOpenCreateEmployerDrawer] = useState(false)
  const [isOpenLog, setIsOpenLog] = useState(false)
  const { user } = useAppSelector((state: RootState) => state.userReducer)

  const keywords = searchQuery.get('keywords')

  // Tạo params cho API
  const searchParams = useMemo(
    () => {
      let companyId: number | null = null

      if (user?.role?.id === RoleIdEnum.USER_EMPLOYER) {
        companyId = user.company_id
      }

      return serializeQuery({
        page: searchQuery.get('page'),
        per_page: searchQuery.get('per_page'),
        keywords: searchQuery.get('keywords'),
        contract_start_date: searchQuery.get('contract_start_date'),
        contract_end_date: searchQuery.get('contract_end_date'),
        status: searchQuery.get('status'),
        ids: companyId ? [companyId] : [searchQuery.get('company_id')],
        perPage: searchQuery.get('perPage')
      })
    }
      ,
    [searchQuery, user]
  )

  useEffect(() => {
    if (keywords) {
      updateQuery({ page: undefined })
    }
  }, [keywords])

  const { refetch, data: companies } = useQuery({
    ...Company.objects.paginateQueryFactory(searchParams)
  })

  const handleSearch = (value: string) => {
    updateQuery({
      search: value || undefined,
      page: 1
    })
  }

  const handleAddEmployee = () => {
    setIsOpenCreateEmployerDrawer(true)
  }

  const handleOpenLog = () => {
    setIsOpenLog(true)
  }

  return (
    <BoxPage title={__('Employer Management')} breadcrumbs={[{ label: __('Employer Management') }]}>
      <Card
        sx={{
          borderRadius: 3
        }}
      >
        <CardContent sx={{ padding: 0 }}>
          <EmployerTableFilter onSearch={handleSearch} onAddEmployee={handleAddEmployee} onOpenLogs={handleOpenLog} />
          <EmployerTable data={companies?.data || []} meta={companies?.meta} refetch={refetch} />
        </CardContent>
      </Card>
      <CreateEmployerDrawer
        open={isOpenCreateEmployerDrawer}
        setOpen={setIsOpenCreateEmployerDrawer}
        onSuccess={() => {
          refetch()
        }}
      />
      <AppLogs
        open={isOpenLog}
        setOpen={setIsOpenLog}
        title={__('History Menu Employer')}
        object_type={ActivityLogTypeEnum.Company}
      />
    </BoxPage>
  )
}

export default Employer
